var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 123,
    viewBox: "0 0 89 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2709_4588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4665 123.151H6.76743C4.97322 123.149 3.25307 122.436 1.98437 121.169C0.715666 119.902 0.00202521 118.185 0 116.393V6.75841C0.00202521 4.96659 0.715666 3.24873 1.98437 1.98173C3.25307 0.714716 4.97322 0.00202251 6.76743 0H82.4665C84.2607 0.00202251 85.9809 0.714716 87.2496 1.98173C88.5183 3.24873 89.2319 4.96659 89.2339 6.75841V116.393C89.2319 118.185 88.5183 119.902 87.2496 121.169C85.9809 122.436 84.2607 123.149 82.4665 123.151Z",
    fill: "#D9EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6005 118.84H6.63497C6.08188 118.839 5.55163 118.619 5.16054 118.229C4.76945 117.838 4.54946 117.309 4.54883 116.756V6.39585C4.54946 5.8435 4.76945 5.31396 5.16054 4.92339C5.55163 4.53283 6.08188 4.31313 6.63497 4.3125H82.6005C83.1536 4.31313 83.6839 4.53283 84.075 4.92339C84.466 5.31396 84.686 5.8435 84.6867 6.39585V116.756C84.686 117.309 84.466 117.838 84.075 118.229C83.6839 118.619 83.1536 118.839 82.6005 118.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3296 2.64596C44.6476 2.64596 44.9053 2.38856 44.9053 2.07103C44.9053 1.7535 44.6476 1.49609 44.3296 1.49609C44.0117 1.49609 43.7539 1.7535 43.7539 2.07103C43.7539 2.38856 44.0117 2.64596 44.3296 2.64596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6639 62.6914H27.4844V64.5535H77.6639V62.6914Z",
    fill: "#D9EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6639 68.5859H27.4844V70.448H77.6639V68.5859Z",
    fill: "#D9EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6639 74.4844H27.4844V76.3465H77.6639V74.4844Z",
    fill: "#D9EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9392 63.8438H11.5703V75.1975H22.9392V63.8438Z",
    fill: "#D9EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6639 87.4023H27.4844V89.2644H77.6639V87.4023Z",
    fill: "#D9EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6639 93.3008H27.4844V95.1629H77.6639V93.3008Z",
    fill: "#D9EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6639 99.1992H27.4844V101.061H77.6639V99.1992Z",
    fill: "#D9EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9392 88.5547H11.5703V99.9084H22.9392V88.5547Z",
    fill: "#D9EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2621 20.0485L33.6055 27.6406L40.9445 46.5914L60.6012 38.9992L53.2621 20.0485Z",
    fill: "#ADD5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1792 45.8994L28.2285 25.3693L49.5026 17.1523L57.4533 37.6824L36.1792 45.8994ZM29.0367 25.7261L36.5366 45.0922L56.645 37.3256L49.1451 17.9595L29.0367 25.7261Z",
    fill: "#73ACC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2709_4588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 123,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageImage);
export default __webpack_public_path__ + "static/media/messageImage.427fd390bd0c104b79f8b494835a7c94.svg";
export { ForwardRef as ReactComponent };